import { equals, filter, keys, reject } from 'ramda';
import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { exists } from '@utils/general';
import { checkbox, optionalString, requiredString } from '@utils/validation';

export const testContent = {
	page_header: 'Update Account',
	profile_picture_label: 'Profile Photo',
	first_name_label: 'First Name',
	first_name_placeholder: 'First Name',
	last_name_label: 'Last Name',
	last_name_placeholder: 'Last Name',
	pronouns_label: 'What pronouns do you use?',
	email_label: 'Email',
	email_disclaimer:
		'<p>To change your email address please contact support at <a href="https://support.folxhealth.com/">https://support.folxhealth.com/</a></p>',
	phone_number_label: 'Mobile number',
	phone_number_placeholder: '(123) 456-7890',
	sms_opt_in_label: 'I would like to recieve text notifications',
	innerspace_label: 'Community platform display name',
	innerspace_placeholder: 'Community platform display name',
};

export const PRONOUNS = 'preferredPronouns';
export const OTHER = 'other';
export const HAS_OTHER_PRONOUNS = 'hasOtherPronouns';

const pronounMessage = 'Enter at least one pronoun';

const baseSchema = {
	selfieImage: optionalString,
	affirmingFirstName: requiredString(commonErrors.responseRequired),
	affirmingLastName: requiredString(commonErrors.responseRequired),
	[PRONOUNS]: z
		.any()
		.transform((values: Record<string, unknown>) => {
			const otherPronouns = exists(values[OTHER]) ? [values[OTHER]] : [];
			const boolPronouns = reject((pronoun: string) => equals(OTHER)(pronoun))(keys(values));
			const filteredPronouns = filter((pronoun: string) => {
				const isNotNumber = equals(NaN);
				return values[pronoun] && isNotNumber(Number(pronoun));
			}, boolPronouns);
			return [...otherPronouns, ...filteredPronouns];
		})
		.refine((pronouns: string[]) => (pronouns?.length ?? 0) > 0, pronounMessage),
	[HAS_OTHER_PRONOUNS]: checkbox,
	nickname: optionalString,
};

export const schema = z.object(baseSchema);

export const smsSchema = z.object({
	...baseSchema,
	smsNumber: requiredString(commonErrors.responseRequired),
});
